import {
  countUnacknowledgedPlantRequests,
  plantRequestAlertOrders,
  plantRequestPhase,
  plantRequestStatusCopy,
  purchaserReviewCopy,
} from "@/lib/manufacturing/plantMaterialRequest";
import type { MfgPurchaseOrder } from "@/lib/manufacturing/purchaseOrderTypes";

export function PlantMaterialRequestPurchaserBanner(props: {
  orders: MfgPurchaseOrder[];
  onReview: () => void;
}) {
  const count = countUnacknowledgedPlantRequests(props.orders);
  const text = purchaserReviewCopy(count);
  if (!text) return null;
  return (
    <div
      role="status"
      className="flex flex-wrap items-center justify-between gap-2 rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-950 dark:border-amber-500/60 dark:bg-amber-950/40 dark:text-amber-100"
    >
      <p className="min-w-0 font-medium">{text}</p>
      <button
        type="button"
        className="shrink-0 rounded-md bg-amber-700 px-2.5 py-1 text-xs font-semibold text-white hover:bg-amber-800 dark:bg-amber-600 dark:hover:bg-amber-500"
        onClick={props.onReview}
      >
        Review requests
      </button>
    </div>
  );
}

export function PlantMaterialRequestStatusStrip(props: {
  orders: MfgPurchaseOrder[];
}) {
  const rows = plantRequestAlertOrders(props.orders);
  if (rows.length === 0) return null;
  return (
    <ul className="space-y-1.5">
      {rows.map((order) => {
        const phase = plantRequestPhase(order, props.orders);
        if (!phase) return null;
        return (
          <li
            key={order.id}
            className="rounded-md border border-gray-200 bg-gray-50 px-3 py-1.5 text-xs text-gray-800 dark:border-zinc-700 dark:bg-zinc-900 dark:text-zinc-100"
          >
            <span className="font-semibold">Request {order.po_number}.</span>{" "}
            {plantRequestStatusCopy(phase, {
              expectedDeliveryOn: order.expected_delivery_on,
              poNumber: order.po_number,
            })}
          </li>
        );
      })}
    </ul>
  );
}
